function init_datepickers() {

    //Initialise datepicker fields
    $('.is-datepicker').each(function(i) {
        var $alt = $(this).siblings('.is-datepicker-alt');
        var $that = $(this);

        $(this).datepicker({
            language: 'en',
            dateFormat: datepicker_format,
            altField: $alt,
            altFieldDateFormat: 'yyyy-mm-dd 00:00:00',
            clearButton: true,
            autoClose: true,
            onSelect: function onSelect(formattedDate, date) {
                if($that.closest('form').hasClass('ajax-form')) {
                    $alt.trigger('change');
                }
            }
        });

        //If we have a preset date loaded from server, set it to calendar on load
        if($alt.data('year')) {

            //We -1 from month because JS months start from 0 (indexed)
            $(this).data('datepicker').selectDate(new Date($alt.data('year'), ($alt.data('month') - 1), $alt.data('day')));
        }
    });
}

$(function() {
    //Initialise datepickers
    init_datepickers();
});
